export default {
  name: 'Call to action section - 2',
  tab: 'call to action',
  type: 'content-default-section',
  content: {
    title: 'Call to action',
    introtext:
      '<p>Aenean lacinia bibendum nulla sed consectetur. Sed posuere consectetur est at lobortis. Etiam porta sem malesuada magna mollis euismod. Morbi leo risus, porta ac consectetur ac.</p>',
    image: '',
    buttons:
      '[{"button-text":"Call to action","button-link":"#section-1","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image':
      '/storage/media/samples/federica-galli-pF1ug8ysTtY-unsplash.jpg',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h4',
    'introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'md',
    'content-horizontal-alignment': 'start',
    'content-box': '1',
    'content-box-color': 'var(--background-color)',
    'content-box-padding': '40px',
    'content-box-opacity': '1',
    'content-box-elevation': '12',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '1',
    'content-vertical-alignment': 'start',
    'image-size': 'sm',
    'image-position': 'left'
  },
  advanced: {}
}
